/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether the payload was revealed or its evidence is unavailable or expired.
 */
export const RevealState = {
  Available: "available",
  EvidenceNotStored: "evidence_not_stored",
} as const;
/**
 * Whether the payload was revealed or its evidence is unavailable or expired.
 */
export type RevealState = ClosedEnum<typeof RevealState>;

export type RiskRevealPayloadResult = {
  /**
   * The mediated execution the payload belongs to.
   */
  executionId?: string | undefined;
  /**
   * When the stored payload is deleted. Absent when reveal_state is evidence_not_stored.
   */
  expiresAt?: Date | undefined;
  /**
   * The risk result ID.
   */
  id: string;
  /**
   * The exact text the scanners inspected: the tools/call arguments JSON for a request, or the extracted result text for a response. Empty when reveal_state is evidence_not_stored.
   */
  payload: string;
  /**
   * Execution phase the payload was scanned in (request or response).
   */
  phase?: string | undefined;
  /**
   * Whether the payload was revealed or its evidence is unavailable or expired.
   */
  revealState: RevealState;
};

/** @internal */
export const RevealState$inboundSchema: z.ZodMiniEnum<typeof RevealState> = z
  .enum(RevealState);

/** @internal */
export const RiskRevealPayloadResult$inboundSchema: z.ZodMiniType<
  RiskRevealPayloadResult,
  unknown
> = z.pipe(
  z.object({
    execution_id: z.optional(z.string()),
    expires_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    id: z.string(),
    payload: z.string(),
    phase: z.optional(z.string()),
    reveal_state: RevealState$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "execution_id": "executionId",
      "expires_at": "expiresAt",
      "reveal_state": "revealState",
    });
  }),
);

export function riskRevealPayloadResultFromJSON(
  jsonString: string,
): SafeParseResult<RiskRevealPayloadResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskRevealPayloadResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskRevealPayloadResult' from JSON`,
  );
}
